// src/features/tasks/components/TasksFiltersAndControls.jsx
import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  FilterList as FilterListIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FILTER_OPTIONS = [
  { value: 'all', labelKey: 'tasks:filtering.all' },
  { value: 'my-tasks', labelKey: 'tasks:filtering.my_tasks' },
  { value: 'today', labelKey: 'tasks:filtering.today' },
  { value: 'overdue', labelKey: 'tasks:filtering.overdue_tasks' },
  { value: 'pending', labelKey: 'tasks:filtering.pending' },
  { value: 'in-progress', labelKey: 'tasks:filtering.in_progress' },
  { value: 'completed', labelKey: 'tasks:filtering.completed' },
];

export default function TasksFiltersAndControls({
  currentFilter,
  selectedCategory,
  searchTerm,
  categories,
  onCategoryChange,
  onSearchChange,
}) {
  const { t } = useTranslation(['tasks']);

  const currentFilterOption = FILTER_OPTIONS.find(opt => opt.value === currentFilter);

  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        mb: 3,
        alignItems: 'stretch'
      }}
    >
      <TextField
        placeholder={t('tasks:filtering.search_placeholder')}
        value={searchTerm}
        onChange={onSearchChange}
        sx={{ flex: 1, minWidth: 300 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <FormControl sx={{ minWidth: 250 }}>
        <InputLabel id="tasks-filters-and-controls-category-label">{t('tasks:filtering.category')}</InputLabel>
        <Select labelId="tasks-filters-and-controls-category-label"
          value={selectedCategory}
          onChange={onCategoryChange}
          label={t('tasks:filtering.category')}
        >
          <MenuItem value="">{t('tasks:filtering.all_categories')}</MenuItem>
          {categories.map((category) => (
            <MenuItem key={category.category_id} value={category.category_id}>
              <Box display="flex" alignItems="center" gap={1}>
                {category.color_code && (
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      backgroundColor: category.color_code,
                    }}
                  />
                )}
                {category.name}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}